import { showErrorToast } from "../lib/Notifications";
import { extractErrorDetail } from "./extractErrorDetail";

export const getErrorMessage = (error: unknown, message = "request failed"): string =>
  extractErrorDetail(error) ?? message;

export const handleApiError = (error: unknown) => {
  showErrorToast(getErrorMessage(error));
};

export const parseObjectErrorResponse = (error: string | Record<string, unknown>) => {
  if (typeof error === "object") {
    return error;
  }

  try {
    return JSON.parse(error);
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    return {};
  }
};
